import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Radio,
  ListItemAvatar,
  Avatar,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";

import { styles } from "./styles";

import { TVessel } from "@/types/vessel";

interface IBoatListItem {
  vessel: TVessel;
  onEditOpenModal: (e: React.MouseEvent<HTMLDivElement>, vessel: TVessel) => void;
  onChangeBoat: (id: number) => void;
}

function BoatListItem({ vessel, onChangeBoat, onEditOpenModal }: IBoatListItem) {
  return (
    <ListItem
      disablePadding
      sx={{
        ...styles.listItemButton,
        ...(vessel.current && {
          border: "2px solid rgba(25, 120, 123, 0.30)",
        }),
      }}
    >
      <ListItemButton
        color="secondary"
        selected={vessel.current}
        sx={{
          p: "12px",
          ...(vessel.current && {
            backgroundColor: "rgba(25, 120, 123, 0.04)",
          }),
          cursor: "pointer",
        }}
        onClick={(e) => {
          onEditOpenModal(e, vessel);
        }}
      >
        <ListItemAvatar>
          <Avatar
            alt="Boat Image"
            src={vessel?.asset_links?.[0] ?? ""}
            sx={styles.avatar}
            variant="square"
          />
        </ListItemAvatar>
        <ListItemText
          primary={vessel.name}
          primaryTypographyProps={{
            variant: "subtitle1",
            color: "secondary",
          }}
          secondary={vessel.manufacturer_model}
          secondaryTypographyProps={{
            variant: "body2",
          }}
        />

        <ListItemIcon>
          <IconButton
            color="primary"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onEditOpenModal(e as unknown as React.MouseEvent<HTMLDivElement>, vessel);
            }}
          >
            <EditIcon />
          </IconButton>
        </ListItemIcon>

        <ListItemIcon>
          <Radio
            checked={vessel.current}
            color="secondary"
            size="small"
            value={vessel.id}
            onClick={(e) => {
              e.stopPropagation();
              onChangeBoat(vessel.id);
            }}
          />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
}

export default BoatListItem;
